import React, { lazy } from 'react'
import ComponentLoader from './component-loader'
import AdminLayout from 'screens/admin/AdminLayout'
import { Navigate } from 'react-router-dom'
import { useLocationInfo } from 'context/location'
import Plans from 'screens/admin/Plan'

// DASHBOARD
const Dashboard = ComponentLoader(
  lazy(() => import('screens/admin/Dashboard/dashboard'))
)

// GEOFENCING
const Geofencing = ComponentLoader(
  lazy(() => import('screens/admin/GeoFencing/geofencing'))
)

// VEHICLES (FLEETS)
const VehicleModule = ComponentLoader(
  lazy(() => import('screens/admin/Vehicles'))
)
const Vehicles = ComponentLoader(
  lazy(() => import('screens/admin/Vehicles/vehicles'))
)
const FleetDetail = ComponentLoader(
  lazy(() => import('screens/admin/Vehicles/fleet-detail'))
)
const OldBikes = ComponentLoader(lazy(() => import('screens/admin/Vehicles/bike')))
const BikeControl = ComponentLoader(
  lazy(() => import('screens/admin/Vehicles/bike-control'))
)

// BIKES (INDIVIDUAL)
const BikesModule = ComponentLoader(
  lazy(() => import('screens/admin/Bikes'))
)
const Bikes = ComponentLoader(
  lazy(() => import('screens/admin/Bikes/bikes'))
)

// RIDERS
const Riders = ComponentLoader(
  lazy(() => import('screens/admin/Riders/riders'))
)
// PRICING
const Pricing = ComponentLoader(
  lazy(() => import('screens/admin/Pricing/pricing'))
)
// E-BIKE
const EbikeModule = ComponentLoader(lazy(() => import('screens/admin/E-Bikes')))
const Ebikes = ComponentLoader(
  lazy(() => import('screens/admin/E-Bikes/e.bikes'))
)

// CAMPAIGNS
const CampaignModule = ComponentLoader(
  lazy(() => import('screens/admin/Campaigns/'))
)
const BroadCastModule = ComponentLoader(
  lazy(() => import('screens/admin/BroadCast/'))
)
const CreateCampaign = ComponentLoader(
  lazy(() => import('screens/admin/Campaigns/create/create-campaign'))
)

const CampaignInsight = ComponentLoader(
  lazy(() => import('screens/admin/Campaigns/insight/'))
)

//Reward
const RewardModule = ComponentLoader(lazy(() => import('screens/admin/Reward')))

// GROWTHTOOL
const GrowthToolModule = ComponentLoader(
  lazy(() => import('screens/admin/GrowthTool'))
)
const GrowthTool = ComponentLoader(
  lazy(() => import('screens/admin/GrowthTool/growthtool'))
)

// CUSTOMER
const Customers = ComponentLoader(
  lazy(() => import('screens/admin/Customers/customers'))
)
const Insight = ComponentLoader(
  lazy(() => import('screens/admin/Customers/view-insight'))
)
const Info = ComponentLoader(
  lazy(() => import('screens/admin/Customers/customer-info'))
)

// SCANNER
const ScannerModule = ComponentLoader(
  lazy(() => import('screens/admin/Scanner/'))
)
const Scanner = ComponentLoader(
  lazy(() => import('screens/admin/Scanner/scanners'))
)
const UsercodeTable = ComponentLoader(
  lazy(() => import('screens/admin/Scanner/usercode-Table'))
)

const Staff = ComponentLoader(lazy(() => import('screens/admin/Scanner/Staff')))
const ScannerLogs = ComponentLoader(
  lazy(() => import('screens/admin/Scanner/logs'))
)
// NOTIFICATION
const CreateBroadCast = ComponentLoader(
  lazy(() => import('screens/admin/BroadCast/create'))
)
const UpdateBroadCast = ComponentLoader(
  lazy(() => import('screens/admin/BroadCast/create'))
)
const ViewLogs = ComponentLoader(
  lazy(() => import('screens/admin/BroadCast/view-logs'))
)
const BroadCast = ComponentLoader(
  lazy(() => import('screens/admin/BroadCast/broadcast'))
)
const Notification = ComponentLoader(
  lazy(() => import('screens/admin/BroadCast/index'))
)
const BroadCastLogs = ComponentLoader(
  lazy(() => import('screens/admin/BroadCast/create'))
)
const PushAutomation = ComponentLoader(
  lazy(() => import('screens/admin/BroadCast/push-automation'))
)

// WEBHOOK
const WebhookModule = ComponentLoader(
  lazy(() => import('screens/admin/Webhook/'))
)
const Webhook = ComponentLoader(
  lazy(() => import('screens/admin/Webhook/webhook-list'))
)
const WebhookLogs = ComponentLoader(
  lazy(() => import('screens/admin/Webhook/view-logs'))
)
const CreateWebhook = ComponentLoader(
  lazy(() => import('screens/admin/Webhook/create/create-webhook'))
)
const UpdateWebhook = ComponentLoader(
  lazy(() => import('screens/admin/Webhook/create/create-webhook'))
)

// SETTINGS
const GeneralInfo = ComponentLoader(
  lazy(() => import('screens/admin/GeneralInfo/generalinfo'))
)
const Qrcode = ComponentLoader(
  lazy(() => import('screens/admin/GrowthTool/create/qrcode'))
)
const Formlink = ComponentLoader(
  lazy(() => import('screens/admin/GrowthTool/create/formlink'))
)
const Billings = ComponentLoader(
  lazy(() => import('screens/admin/Billings/billing'))
)
const Transactions = ComponentLoader(
  lazy(() => import('screens/admin/Transactions/transactions'))
)
const Profile = ComponentLoader(
  lazy(() => import('screens/admin/Profile/profile'))
)

const GeoLocationModule = ComponentLoader(
  lazy(() => import('screens/admin/GeoLocation'))
)
const ApiKey = ComponentLoader(
  lazy(() => import('screens/admin/ApiKey/apikey'))
)
const Integration = ComponentLoader(
  lazy(() => import('screens/admin/Integration/integration'))
)
const IntegrateStripe = ComponentLoader(
  lazy(() => import('screens/public/stripe/stripe'))
)

// RESERVATIONS
const Reservations = ComponentLoader(
  lazy(() => import('screens/admin/Reservations/reservations'))
)

// NOTIFICATIONS (in-app banners)
const Notifications = ComponentLoader(
  lazy(() => import('screens/admin/Notifications/notifications'))
)

// PROMOTIONS
const Promotions = ComponentLoader(
  lazy(() => import('screens/admin/Promotions/promotions'))
)

// USER RANKING
const UserRanking = ComponentLoader(
  lazy(() => import('screens/admin/UserRanking/user-ranking'))
)

// REVENUE SHARING (settings)
const RevenueSharing = ComponentLoader(
  lazy(() => import('screens/admin/RevenueSharing/revenue-sharing'))
)

const AdminRoutes = () => {
  return [
    {
      path: '',
      element: <AdminLayout />,
      children: [
        {
          path: 'dashboard',
          element: <Dashboard />,
        },
        {
          path: 'geofencing',
          element: <Geofencing />,
        },
        {
          path: 'riders',
          element: <Riders />,
        },
        {
          path: 'vehicles',
          element: <VehicleModule />,
          children: [
            {
              path: '',
              index: true,
              element: <Vehicles />,
            },
            {
              path: 'detail',
              index: true,
              element: <OldBikes />,
            },
            {
              path: 'detail/:imei',
              index: true,
              element: <FleetDetail />,
            },
            {
              path: 'bike-control',
              element: <BikeControl />,
            },
          ],
        },
        {
          path: 'bikes',
          element: <BikesModule />,
          children: [
            {
              path: '',
              index: true,
              element: <Bikes />,
            },
            {
              path: 'bike-control',
              element: <BikeControl />,
            },
          ],
        },
        {
          path: 'Bikes',
          element: <VehicleModule />,
          children: [
            {
              path: '',
              index: true,
              element: <Vehicles />,
            },
            {
              path: 'detail',
              index: true,
              element: <Bikes />,
            },
            {
              path: 'detail/:imei',
              index: true,
              element: <FleetDetail />,
            },
            {
              path: 'bike-control',
              element: <BikeControl />,
            },
          ],
        },
        {
          path: 'pricing',
          element: <Pricing />,
        },
        {
          path: 'ebikes',
          element: <EbikeModule />,
          children: [
            {
              path: '',
              index: true,
              element: <Ebikes />,
            },
          ],
        },
        {
          path: 'plans',
          element: <Plans />,
        },
        {
          path: 'transactions',
          element: <Transactions />,
        },
        {
          path: 'reservations',
          element: <Reservations />,
        },
        {
          path: 'notifications',
          element: <Notifications />,
        },
        {
          path: 'promotions',
          element: <Promotions />,
        },
        {
          path: 'user-ranking',
          element: <UserRanking />,
        },
        {
          path: 'profile',
          element: <Profile />,
        },
        {
          path: 'broadcast',
          element: <BroadCastModule />,
          children: [
            {
              path: '',
              index: true,
              element: <BroadCast />,
            },
            {
              path: 'create-broadcast',
              element: <CreateBroadCast />,
            },
            {
              path: 'update',
              element: <UpdateBroadCast />,
            },
            {
              path: 'view-logs',
              element: <ViewLogs />,
            },
          ],
        },
        {
          path: 'scanner',
          element: <ScannerModule />,
          children: [
            {
              path: '',
              element: <Scanner />,
              index: true,
            },
            {
              path: 'staff',
              element: <Staff />,
            },
            {
              path: 'logs',
              element: <ScannerLogs />,
            },
            {
              path: 'usercode-table',
              element: <UsercodeTable />,
            },
          ],
        },
        {
          path: 'settings',
          children: [
            {
              path: 'generalinfo',
              element: <GeneralInfo />,
            },
            {
              path: 'billings',
              element: <Billings />,
            },
            {
              path: 'geo-location',
              element: <GeoLocationModule />,
            },
            {
              path: 'apikey',
              element: <ApiKey />,
            },
            {
              path: 'integration',
              element: <Integration />,
            },
            {
              path: 'revenue-sharing',
              element: <RevenueSharing />,
            },
            {
              path: '',
              index: true,
              element: <Navigate replace to={'./generalinfo'} />,
            },
            {
              path: '*',
              element: <Navigate replace to={'./generalinfo'} />,
            },
          ],
        },

        {
          path: '',
          index: true,
          element: <Navigate replace to={'./dashboard'} />,
        },
        {
          path: '*',
          index: true,
          element: <Navigate replace to={'./dashboard'} />,
        },
      ],
    },
  ]
}

export default AdminRoutes
